const initState = {
  reports2: [],
};

const report2Reducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_REPORTS_2":
      return { ...state, reports2: action.payload };
    default:
      return state;
  }
};

export default report2Reducer;
